import { RecentSearchList, RecentSearchListItem } from '@/src/hooks/srp/recentSearch'

const KEY_MAP: Record<string, string> = {
    from: 'fr',
    to: 'to',
    fromCity: 'fc',
    toCity: 'tc',
    departDate: 'dd',
    returnDate: 'rd',
    numberOfPax: 'np',
    flightClass: 'cl',
    adults: 'ad',
    childs: 'ch',
    infants: 'in'
}

const REVERSE_KEY_MAP: Record<string, string> = Object.fromEntries(
    Object.entries(KEY_MAP).map(([full, short]) => [short, full])
)

function compressItem(item: RecentSearchListItem): Record<string, unknown> {
    const compressed: Record<string, unknown> = {}
    for (const [key, value] of Object.entries(item)) {
        compressed[KEY_MAP[key] || key] = value
    }
    return compressed
}

function decompressItem(item: Record<string, unknown>): RecentSearchListItem {
    const decompressed: Record<string, unknown> = {}
    for (const [key, value] of Object.entries(item)) {
        decompressed[REVERSE_KEY_MAP[key] || key] = value
    }
    return decompressed as unknown as RecentSearchListItem
}

export function compressRecentSearch(data: RecentSearchList): Record<string, Record<string, unknown>[]> {
    const compressed: Record<string, Record<string, unknown>[]> = {}
    for (const [locale, items] of Object.entries(data)) {
        compressed[locale] = items.map(compressItem)
    }
    return compressed
}

export function decompressRecentSearch(data: Record<string, Record<string, unknown>[]>): RecentSearchList {
    const decompressed: RecentSearchList = {}
    for (const [locale, items] of Object.entries(data)) {
        if (!Array.isArray(items)) continue
        decompressed[locale] = items.map(decompressItem)
    }
    return decompressed
}
